export default __webpack_public_path__ + "static/media/ic_search.10d4ecfd.svg";